export interface Identified { id: number; }

export function reorderById<T extends Identified>(items: T[], draggedId: number, overId: number): T[] {
  if (draggedId === overId) return items;
  const from = items.findIndex(item => item.id === draggedId);
  const to = items.findIndex(item => item.id === overId);
  if (from < 0 || to < 0) return items;
  const next = [...items];
  const [dragged] = next.splice(from, 1);
  next.splice(to, 0, dragged!);
  return next;
}

export function orderByIds<T extends Identified>(items: T[], ids: number[]): T[] {
  if (ids.length !== items.length || new Set(ids).size !== ids.length) return items;
  const byId = new Map(items.map(item => [item.id, item]));
  if (ids.some(id => !byId.has(id))) return items;
  return ids.map(id => byId.get(id)!);
}

export async function commitReorder<T>(
  next: T[],
  prior: T[],
  persist: (items: T[]) => Promise<void>,
  rollback: (items: T[]) => void,
  failed: (error: unknown) => void,
): Promise<boolean> {
  try {
    await persist(next);
    return true;
  } catch (error) {
    rollback(prior);
    failed(error);
    return false;
  }
}
